import { AbstractControl, ValidatorFn } from '@angular/forms';

export const mutuallyExclusiveRequiredValidator = (
    params: {
        controlName: string;
        controlLabel?: string;
    }[],
): ValidatorFn => {
    return (control: AbstractControl) => {
        let minimumSelected: any = false;
        const mutuallyExclusiveRequired: string[] = [];
        const controlObjects = params.filter((control) => control.controlName.trim() !== '');

        controlObjects.forEach((controlObject, index) => {
            const currentControl = control?.get(controlObject.controlName);

            //Check first if control exists on the form
            if (currentControl) {
                if (currentControl?.value) {
                    minimumSelected = true;
                } else {
                    mutuallyExclusiveRequired.push(controlObject.controlLabel ?? controlObject.controlName);
                }
            }
        });

        return minimumSelected ? null : { mutuallyExclusiveRequired };
    };
};
